import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export default function Header() {
  const [showSidebar, setShowSidebar] = useState(false)
  return (
    <header className='bg-white/80 backdrop-blur-lg text-dark-800 container justify-between flex items-center px-10 header shadow-soft sticky top-0 z-50 border-b border-gray-100' style={{minHeight: '70px', width: '100%'}}>
      <Link to={'/'} className='h-full my-3 transition-transform duration-300 hover:scale-105' style={{width: '120px', height: 'auto'}}>
        <img src="https://wnmfpa.hstonline.tech/img/AWARDSLOGO.png" alt="Awards Logo" className='img-fit'/>
      </Link>

      <nav className="navList flex items-center gap-8 h-full">
        <Link to={'/'} className='group relative'>
          <p className='text-base font-medium text-dark-700 group-hover:text-primary-600 transition-colors duration-300'>
            Home
          </p>
          <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-primary group-hover:w-full transition-all duration-300'></span>
        </Link>
        <Link to={'/about'} className='group relative'>
          <p className='text-base font-medium text-dark-700 group-hover:text-primary-600 transition-colors duration-300'>
            About Us
          </p>
          <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-primary group-hover:w-full transition-all duration-300'></span>
        </Link>
        <Link to={'/terms'} className='group relative'>
          <p className='text-base font-medium text-dark-700 group-hover:text-primary-600 transition-colors duration-300'>
            Terms & Conditions
          </p>
          <span className='absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-primary group-hover:w-full transition-all duration-300'></span>
        </Link>
      </nav>

      <button
        onClick={()=>setShowSidebar(!showSidebar)}
        className="text-2xl text-dark-700 hover:text-primary-600 transition-colors duration-300"
        aria-label="Toggle menu"
      >
        <i className="fa fa-bars"></i>
      </button>

      {showSidebar && (
        <div className="sidebar fixed w-full h-screen top-0 left-0 right-0 bottom-0 z-[100] animate-fade-in">
          <div
            onClick={()=>setShowSidebar(false)}
            className='bg-black/40 backdrop-blur-sm w-2/5 h-full'
          ></div>
          <aside className='bg-white fixed right-0 top-0 h-full shadow-strong animate-slide-down' style={{minWidth: '60%', maxWidth: '400px'}}>
            <div className="w-full flex px-6 py-5 justify-between items-center border-b border-gray-200">
              <h1 className='font-bold text-xl bg-gradient-primary bg-clip-text text-transparent'>E-Vote</h1>
              <button
                onClick={()=>setShowSidebar(false)}
                className="text-2xl text-dark-600 hover:text-primary-600 transition-colors duration-300"
                aria-label="Close menu"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
            <nav className="flex flex-col mt-6 px-4 gap-2">
              <Link
                onClick={()=>setShowSidebar(false)}
                to={'/'}
                className='bg-gradient-to-r from-primary-50 to-primary-100 hover:from-primary-100 hover:to-primary-200 rounded-lg flex justify-center items-center transition-all duration-300 shadow-soft hover:shadow-medium h-12 font-medium text-primary-700'
              >
                HOME
              </Link>
              <Link
                onClick={()=>setShowSidebar(false)}
                to={'/about'}
                className='bg-gradient-to-r from-primary-50 to-primary-100 hover:from-primary-100 hover:to-primary-200 rounded-lg flex justify-center items-center transition-all duration-300 shadow-soft hover:shadow-medium h-12 font-medium text-primary-700'
              >
                ABOUT
              </Link>
              <Link
                onClick={()=>setShowSidebar(false)}
                to={'/terms'}
                className='bg-gradient-to-r from-primary-50 to-primary-100 hover:from-primary-100 hover:to-primary-200 rounded-lg flex justify-center items-center transition-all duration-300 shadow-soft hover:shadow-medium h-12 font-medium text-primary-700'
              >
                TERMS & CONDITIONS
              </Link>
            </nav>
          </aside>
        </div>
      )}
    </header>
  )
}
